import React from 'react';
import CustomControl from '../../components/CustomControl/CustomControl';
import { STATIC_PATH } from '../../config';

const ThemeChooserItem = ({ theme, checkedTheme, onThemeChange, children }) => (
  <div className={checkedTheme === theme ? `theme-item theme-item--checked` : `theme-item`}>
    <div className="theme-chooser-checkbox">
      <CustomControl
        className={`theme-${theme}-control`}
        type="radio"
        id={`theme-${theme}`}
        name="theme"
        value={theme}
        checked={checkedTheme === theme}
        onChange={onThemeChange}
      >
        <div className="theme-preview">
          <img
            src={`${STATIC_PATH}/img/themes/theme-${theme}-preview.svg`}
            className={`theme-${theme}-preview`}
            alt=""
          />
        </div>
        <div className="theme-chooser-text">
          {children}
        </div>
      </CustomControl>
    </div>
  </div>
);

export default ThemeChooserItem;
